import { useGetAttachmentURI } from "hooks/case-action/useGetAttachmentURI";
import Lightbox from "react-image-lightbox";

export interface AttachmentLightboxProps {
  attachmentUrl: string | null;
  onClose: () => void;
}

/**
 * Displays an image in a lightbox when a valid url is passed in
 * @param attachmentUrl the url of the attachment to display
 * @param onClose a callback function which is triggered when the lightbox should close
 */
export const AttachmentLightbox = ({
  attachmentUrl,
  onClose
}: AttachmentLightboxProps): JSX.Element => {
  const attachmentUri = useGetAttachmentURI(attachmentUrl);
  return (
    <>
      {attachmentUri && (
        <Lightbox
          mainSrc={attachmentUri}
          onCloseRequest={onClose}
          reactModalStyle={{
            overlay: { zIndex: 1500 },
            container: { zIndex: 1500 }
          }}
          onImageLoadError={() => {
            console.log("Error loading image inside Lightbox.");
          }}
        />
      )}
    </>
  );
};
